"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.osmosisDescribePath = void 0;
const utils_1 = require("./utils");
function osmosisDescribePath(path) {
    let pathStr = utils_1.addressNListToBIP32(path);
    let unknown = {
        verbose: pathStr,
        coin: "Atom",
        isKnown: false,
    };
    if (path.length != 5) {
        return unknown;
    }
    if (path[0] != 0x80000000 + 44) {
        return unknown;
    }
    if (path[1] != 0x80000000 + utils_1.slip44ByCoin("Osmo")) {
        return unknown;
    }
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) {
        return unknown;
    }
    if (path[3] !== 0 || path[4] !== 0) {
        return unknown;
    }
    let index = path[2] & 0x7fffffff;
    return {
        verbose: `Osmosis Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Osmo",
        isKnown: true,
        isPrefork: false,
    };
}
exports.osmosisDescribePath = osmosisDescribePath;
